import { Factory } from 'miragejs'
import { faker } from '@faker-js/faker'
import READING_SCALES from 'teacher-ui-client/mirage/fixtures/book-library/reading-scales'
import config from 'teacher-ui-client/config/environment'
import testImage from '@images/test-image.png'
import devBookCover from '@images/book-dev.png'

export default Factory.extend({
  name() {
    return [faker.word.sample(), faker.word.sample()].join(' ')
  },

  hasResources: true,

  description() {
    return faker.lorem.paragraph(10)
  },

  pages() {
    return faker.number.int({
      min: 3,
      max: 30,
    })
  },

  chapters() {
    const length = faker.number.int({
      min: 0,
      max: 10,
    })
    return Array.from({ length }, () => ({ name: faker.lorem.words(3), has_quiz: faker.datatype.boolean() }))
  },

  wordCount() {
    return faker.number.int({
      min: 5,
      max: 200,
    })
  },

  audio() {
    return faker.datatype.boolean()
  },

  narrationAudio() {
    return faker.datatype.boolean()
  },

  hasQuiz() {
    return faker.datatype.boolean()
  },

  coverFullImg() {
    // real book cover images
    // path works when the baseurl is https://books.static.readingeggs.com
    // const covers = [
    //   {
    //     path: '/covers/au/steve_parish/steve_parish_toby_goes_to_school/preview_front_steve_parish_toby_goes_to_school.jpg',
    //     width: 140,
    //     height: 127,
    //   },
    // ]

    if (config.environment === 'development') {
      return { path: devBookCover, width: 149, height: 224 }
    } else if (config.libraryAssetsUrl === '/') {
      // used in test, return the test image path
      return { path: testImage, width: 1, height: 1 }
    } else {
      return null
    }
  },

  // just use the full image, but make black and white by prepending path with /g
  coverPreviewImg() {
    return { ...this.coverFullImg }
  },

  _readingScale() {
    return faker.helpers.arrayElement(READING_SCALES)
  },

  blakeReadingLevel() {
    return this._readingScale['blake-reading-level']
  },

  // something like "10L-20L"
  lexileRange() {
    return this._readingScale['lexile-range']
  },

  // Just chop the lexile range and use the first value
  lexileLevel() {
    return this.lexileRange.split('-')[0]
  },

  readingAge() {
    return faker.number.int({ min: 5, max: 13 })
  },

  yearLevel() {
    return this._readingScale['year-level']
  },

  rrLevel() {
    return this._readingScale['rr-level']
  },

  dra() {
    return this._readingScale.dra
  },

  // eslint-disable-next-line customPlugin/prefer-american-color
  bookColour() {
    return this._readingScale['book-colour']
  },

  fpAz() {
    return this._readingScale['fp-az']
  },
})
